@let hasError = ngControl.errors && ngControl.touched;
<div
  class="border-input-ring border-input rounded-input focus-within:border-input-focus box-border flex w-full bg-inherit text-base"
  [ngClass]="{
    'cursor-not-allowed opacity-60': ngControl.control!.disabled,
    'border-input-error': hasError,
  }"
  [ngStyle]="{
    backgroundColor: inputBackground(),
  }">
  <div
    [id]="id() | appendTestId: 'image-icon'"
    (click)="imageInput.focus()"
    class="border-input-ring peer flex w-16 flex-row items-center justify-center border-r bg-transparent px-2 placeholder-transparent"
    [ngClass]="{
      'cursor-pointer': !ngControl.control!.disabled && !isLoading(),
      'pointer-events-none cursor-not-allowed':
        ngControl.control!.disabled || isLoading(),
    }">
    <span class="material-symbols-rounded pointer-events-none"> image </span>
  </div>
  <div class="rounded-input relative w-full bg-inherit">
    <input
      #imageInput
      [attr.data-testid]="id() | appendTestId: 'input'"
      autocomplete="off"
      [formControl]="imageSearchControl"
      class="peer p-input w-full border-0! bg-transparent placeholder-transparent shadow-none! ring-0! outline-none! focus:border-0! focus:shadow-none! focus:ring-0! focus:outline-none!"
      [ngClass]="{
        'pointer-events-none': ngControl.disabled || isLoading(),
      }"
      [id]="id()"
      [placeholder]="label() ?? ''"
      type="text" />
    <label
      [attr.data-testid]="id() | appendTestId: 'label'"
      class="peer-placeholder-shown:text-input-label peer-focus:text-input-focus pointer-events-none absolute -top-2 left-4 cursor-text bg-inherit text-sm transition-all peer-placeholder-shown:top-3.5 peer-placeholder-shown:text-base peer-focus:-top-2 peer-focus:text-sm"
      [ngClass]="{ 'text-input-error': hasError }"
      [for]="id()">
      {{ formattedLabel() }}
    </label>
    @if (isLoading()) {
      <span
        class="material-symbols-rounded pointer-events-none absolute top-3 right-4 animate-spin text-2xl"
        aria-hidden="true"
        >progress_activity</span
      >
    }
    @if (ngControl.value) {
      <div
        [attr.data-testid]="id() | appendTestId: 'value'"
        class="pointer-events-none absolute top-3.5 right-6 left-4 flex items-center gap-2 truncate bg-inherit">
        @let imagePath = imageStore.getThumbnailPath(ngControl.value.id);
        @if (imagePath) {
          <img [src]="imagePath" alt="Image Preview" class="h-6" />
        }
        {{ imageSearchControl.value }}
      </div>
      @if (!isLoading()) {
        <span
          class="material-symbols-rounded absolute top-3.5 right-4 bottom-0 z-10 flex cursor-pointer items-center text-xl"
          [ngClass]="{
            'pointer-events-none cursor-not-allowed':
              ngControl.control!.disabled,
          }"
          [attr.data-testid]="id() | appendTestId: 'clear'"
          (click)="clearSelection()">
          close
        </span>
      }
    }
    @if (showList()) {
      <div class="fixed top-0 right-0 bottom-0 left-0 z-10 w-full"></div>
      <ul
        tabindex="-1"
        [attr.data-testid]="id() | appendTestId: 'options'"
        class="focus:border-input-focus border-input-ring border-input rounded-input absolute z-20 max-h-[300px] w-full overflow-y-scroll bg-inherit focus:outline-hidden">
      @for (image of filteredImages; track image.id; let index = $index) {
        <li
          [attr.data-testid]="
            id() | appendTestId: 'image-option' | appendTestId: image.filename
          "
          class="p-drop-down-list-item hover:bg-standard-hover-main flex cursor-pointer flex-row items-center"
          [ngClass]="{
            'text-input-focus': ngControl.control!.value === image,
            'bg-standard-hover': selectedItem() === index,
            'rounded-t-lg': index === 0,
            'rounded-b-lg': index === filteredImages.length - 1,
          }"
          (click)="selectImage(image)">
          @let imagePath = imageStore.getThumbnailPath(image.id);
          @if (imagePath) {
            <img [src]="imagePath" alt="Image Preview" class="h-10 pr-2" />
          }
          {{ image.filename }}
        </li>
      }
      @if (filteredImages.length === 0) {
        <div
          class="p-drop-down-list-item"
          [attr.data-testid]="id() | appendTestId: 'option'">
          {{
            textStore.texts()
              | filterTexts: ERelationType.noOptions : EEntityType.generic
              | language
          }}
        </div>
      }
      </ul>
    }
  </div>
</div>
@if (hasError && !errorTemplate()) {
  <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
    <ng-content></ng-content>
  </aw-error-message>
}
@if (hasError && errorTemplate()) {
  <aw-error-message [attr.data-testid]="id() | appendTestId: 'error'">
    <ng-container *ngTemplateOutlet="errorTemplate()!"></ng-container>
  </aw-error-message>
}
